

exports.__esModule = true;
exports.$SidebarInstallmentOptionsRoute = undefined;

require('./directive');

var _squid = require('squid');

var $SidebarInstallmentOptionsRoute = exports.$SidebarInstallmentOptionsRoute = _squid.$ComponentRoute.extend('$SidebarInstallmentOptionsRoute', {
    path: 'installmentOptions',
    directive: 'xo-sidebar-installment-options-page',
    titleContent: 'asideHeader.installmentsPanel',
    trackingData: {
        fptiState: 'installment_options',
        templateName: 'tray/installmentOptions.dust',
        pageGoal: 'Installment Options',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-installment-options',
                'pagename2': '%::fullpage-installment-options::hermes:',
                'version': ':%:'
            }
        }
    },
    children: []
});

angular.value("$SidebarInstallmentOptionsRoute", $SidebarInstallmentOptionsRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-installment-options/route.js
// module id = ./pages/xo-sidebar-installment-options/route.js
// module chunks = 1